interface RoleCardProps {
  roleLabel: string;
  description: string;
  isRoleSelected: (role: string) => boolean;
  handleRoleSelect: (role: string) => void;
}

const RoleCard: React.FC<RoleCardProps> = ({ roleLabel, description, isRoleSelected, handleRoleSelect }) => {
  return (
    <section
      className={`cursor-pointer ${!isRoleSelected(roleLabel) && 'opacity-50'}`}
      onClick={() => handleRoleSelect(roleLabel)}
    >
      <div className="flex flex-row items-center gap-2 h-full">
        <div
          className={`w-3 h-3 rounded-full border border-custom-blue ${isRoleSelected(roleLabel) && 'bg-custom-blue'}`}
        ></div>
        <div className="flex flex-col">
          <h2 className="text-custom-black font-medium text-sm">{roleLabel}</h2>
          <p className="text-custom-black text-xs">{description}</p>
        </div>
      </div>
    </section>
  );
};

export default RoleCard;
